import { authRoles } from "./auth/authRoles";

export const navigations = [
  {
    name: "Dashboard",
    path: "/dashboard/default",
    icon: "dashboard",
  },
  // Settings
  {
    label: "SETTINGS",
    icon: "summarize",
    type: "label",
    auth: authRoles.superUser,
  },
  {
    name: "Site Settings",
    icon: "summarize",
    path: "/settings/site",
    auth: authRoles.superUser,
  },
  {
    name: "User Management",
    icon: "summarize",
    path: "/users",
    auth: authRoles.superUser,
  },
  // { label: "REPORTS", type: "label" },
  // {
  //   name: "Table",
  //   icon: "summarize",
  //   path: "/reports/daily",
  // },
  // {
  //   name: "Video Player",
  //   icon: "summarize",
  //   path: "/reports/player",
  // },
  // {
  //   name: "Audio Player",
  //   icon: "summarize",
  //   path: "/reports/audio",
  // },
];
